import { Spinner } from "./Spinner"
import { useClassNames } from "@/hooks/useClassNames"

type LoadingPageProps = {
  message?: string
  className?: string
}

export const LoadingPage = ({ message = "Loading...", className }: LoadingPageProps) => {
  return (
    <div className={useClassNames(
      "flex flex-col items-center justify-center min-h-[400px] space-y-4",
      className
    )}>
      <Spinner size="lg" />
      <p className="text-muted-foreground">{message}</p>
    </div>
  )
}
